module.exports = __webpack_public_path__ + "static/img/6.47f32e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/6.png
// module id = J1JF
// module chunks = 0